// Portada de REGULATORY: diseño base, a completar cuando el módulo tenga
// pantallas. No pide nada al servidor — el módulo aún no tiene endpoints —, así
// que no hay estado de carga ni de error que pintar.
//
// Los bloques de abajo son el esqueleto de lo que vendrá, marcados como
// «próximamente» y sin enlace: un enlace a una pantalla que no existe acabaría
// en el `*` del router y devolvería al usuario aquí mismo, que parece un fallo.
//
// Misma estructura visual que `InicioLogisticaPage` (cabecera con fecha y
// superficie clara/oscura) para que las portadas por área se lean como familia.
import { useTranslation } from 'react-i18next'
import { useAppStore } from '@/store'

const BLOQUES = ['documentacion', 'cumplimiento', 'alertas'] as const

export function InicioRegulatoryPage() {
  const { t, i18n } = useTranslation()
  const { dark } = useAppStore()
  const hoy = new Date()

  const superficie = dark ? 'bg-slate-900/60 border-white/8' : 'bg-white border-slate-200 shadow-sm'
  const tenue = dark ? 'text-slate-400' : 'text-slate-500'
  const linea = dark ? 'border-white/8' : 'border-slate-200'

  return (
    <div className={`flex flex-col gap-5 ${dark ? '-m-6 p-6 bg-slate-950 text-slate-100 min-h-full' : 'text-slate-900'}`}>
      <header className={`flex items-end justify-between gap-3 flex-wrap pb-4 border-b ${linea}`}>
        <div>
          <h1 className="text-xl font-bold leading-tight">{t('inicioRegulatory.titulo')}</h1>
          <p className={`text-[12px] ${tenue}`}>
            {t('inicioRegulatory.subtitulo')} ·{' '}
            {hoy.toLocaleDateString(i18n.language, { weekday: 'long', day: 'numeric', month: 'long' })}
          </p>
        </div>
        <span className={`text-[11px] font-semibold px-2 py-1 rounded-md border ${dark ? 'border-amber-400/30 text-amber-300 bg-amber-400/10' : 'border-amber-200 text-amber-700 bg-amber-50'}`}>
          {t('inicioRegulatory.enConstruccion')}
        </span>
      </header>

      <section className={`rounded-xl border p-5 ${superficie}`}>
        <p className={`text-[13px] leading-relaxed max-w-2xl ${tenue}`}>{t('inicioRegulatory.intro')}</p>
      </section>

      <div className="grid gap-4 md:grid-cols-3">
        {BLOQUES.map(b => (
          <article key={b} className={`rounded-xl border p-4 flex flex-col gap-2 ${superficie}`}>
            <div className="flex items-start justify-between gap-2">
              <h2 className="text-[14px] font-semibold leading-snug">{t(`inicioRegulatory.bloques.${b}.titulo`)}</h2>
              <span className={`shrink-0 text-[10px] uppercase tracking-wide font-semibold ${tenue}`}>
                {t('inicioRegulatory.proximamente')}
              </span>
            </div>
            <p className={`text-[12px] leading-relaxed ${tenue}`}>{t(`inicioRegulatory.bloques.${b}.texto`)}</p>
          </article>
        ))}
      </div>
    </div>
  )
}
